import { ITienDoNhapDiemLopHanhChinhActionTypes } from "../../action-types/tong-hop/ITienDoNhapDiemLopHanhChinhActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { ITienDoNhapDiemLopHanhChinhReducer } from "../../reducer-model/tong-hop/ITienDoNhapDiemLopHanhChinhReducer";

const iniState: ITienDoNhapDiemLopHanhChinhReducer = {
    status: eReducerStatusBase.is_not_initialization,
    tienDoNhapDiems: [],
};

export const tienDoNhapDiemLopHanhChinhReducer = (state = iniState, action: ITienDoNhapDiemLopHanhChinhActionTypes): ITienDoNhapDiemLopHanhChinhReducer => {
    switch (action.type) {
        case "TIEN_DO_NHAP_DIEM_LOP_HANH_CHINH_THANH_PHAN_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "TIEN_DO_NHAP_DIEM_LOP_HANH_CHINH_THANH_PHAN_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                tienDoNhapDiems: action.payload,
            };
        case "TIEN_DO_NHAP_DIEM_LOP_HANH_CHINH_THANH_PHAN_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "TIEN_DO_NHAP_DIEM_LOP_HANH_CHINH_THI_LOAD_START": 
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "TIEN_DO_NHAP_DIEM_LOP_HANH_CHINH_THI_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                tienDoNhapDiems: action.payload,
            };
        case "TIEN_DO_NHAP_DIEM_LOP_HANH_CHINH_THI_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        default:
            return state;
    }
}